export const CARD_STATUS_ACTIVE = 1;
export const CARD_STATUS_OFF = 2;
export const CARD_STATUS_TEMPORARY_BLOCKED = 5;

export const CARD_TYPE_VIRTUAL = 1;
export const CARD_TYPE_PHYSICAL = 2;
